export default __webpack_public_path__ + "static/media/NoNewsBanner.60083d3e.png";